<template>
  <div class="simple-component">
    I am a simple component
    <p>{{ content }}</p>
  </div>
</template>

<script>
export default {
  name: 'WebBuilderSimpleComponent',
  props: {
    content: {
      type: String,
      default: ''
    }
  }
};
</script>
